import { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Input, ModalBody } from 'reactstrap'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'

/*eslint-disable */

const styles = {
  fileUploadContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  fileUploadInput: {
    position: 'absolute',
    zIndex: 10,
    opacity: 0,
    width: '100%',
    left: 0,
    height: '43px',
    width: '121px',
  },

  uploadButton: {
    background: '#f1f1f1',
    display: 'inline-block',
  },

  fileName: {
    fontSize: '13px',
    marginLeft: '15px',
  },
}

const UploadFile = (props) => {
  const [originalName, setOriginalName] = useState('No File Chosen')

  const history = useHistory()

  useEffect(() => {
    !props.showUploadFilePage
      ? history.push(`/course/${props.course_id}/edit`)
      : null
    props.onChangeTitleText('')
  }, [])

  useEffect(() => {
    !props.showUploadFilePage
      ? history.push(`/course/${props.course_id}/edit`)
      : null
  }, [props])

  const onChange = (event) => {
    const originalNameSplit = event.target.value.split(/(\\|\/)/g)

    setOriginalName(originalNameSplit[originalNameSplit.length - 1])
  }

  let language = props.language || {}

  return (
    <form onSubmit={props.uploadFile} id='upload-file'>
      <div className='title-container'>
        <div className='col-6 px-0'>
          <Input
            type='text'
            name='title'
            placeholder={language.settings?.title}
            autoFocus
            value={props.title ? props.title : ''}
            onChange={(event) => props.onChangeTitleText(event.target.value)}
            required
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='upload-video-form-row'>
            <div style={styles.fileUploadContainer}>
              <span
                className='btn btn-disabled px-3 py-1 mt-1'
                style={styles.uploadButton}
              >
                {language.general ? language.general.choose_file : null}
              </span>
              <input
                onChange={onChange}
                style={styles.fileUploadInput}
                type='file'
                name='file'
                required
              />
              <span
                className='text-darker h6 pt-1 pb-0 mb-0'
                style={styles.fileName}
              >
                {originalName}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='custom-control custom-checkbox-info mt-1'>
        <input
          className='custom-control-input'
          id='required_content'
          type='checkbox'
          checked={props.requiredContent}
          onChange={props.setRequired}
        />
        <label
          className='custom-control-label '
          htmlFor='required_content'
          style={{ fontSize: '14px', paddingTop: '2px' }}
        >
          {language?.courses?.required}
        </label>
      </div>

      <div className='col px-0 position-absolute bottom-3'>
        <ProgressiveButton
          placeholder={language.courses ? language.courses.upload : null}
          percent={props.uploadFilePercent}
          status={props.uploadFileStatus}
          language={props.language}
          form='upload-file'
        />
        <Link to={`/course/${props.course_id}/edit`}>
          <CancelModalButton
            text={language?.general?.cancel}
            customFn={() => props.toggleUploadFilePage(false)}
          />
        </Link>
      </div>
    </form>
  )
}

export default (props) => {
  let language = props.language || {}

  return (
    <CustomModal
      size='lg'
      courseId={props.course_id}
      title={language.courses ? language.courses.add_file : null}
    >
      <ModalBody style={{ overflow: 'hidden' }}>
        <UploadFile {...props} />
      </ModalBody>
    </CustomModal>
  )
}
